import BaseApi from "./BaseApi";

const baseUrl = 'api/Distributors';

class DistributorsService {

    static GetALL(): Promise<any> {
        return BaseApi.get(`${baseUrl}/List`);
    }

    static GetById(event: any): Promise<any> {
        return BaseApi.get(`${baseUrl}/Id/${event}`);
    }
    static GetByUf(event: any, idProductType:any|null): Promise<any> {
        return BaseApi.get(`${baseUrl}/UF/${event}/${idProductType}`);
    }
    
    static post(request: any): Promise<number> {
        return BaseApi.post(`${baseUrl}`, request);
    }

    static put(request: any): Promise<number> {
        return BaseApi.put(`${baseUrl}`, request);
    }

}

export default DistributorsService;